import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const KycSuccess = ({ name }) => (
  <section className="pt-16 flex flex-col items-center text-center" data-testid="kyc-success">
    <CheckCircle2 className="w-16 h-16 text-[#3BB54A]" strokeWidth={1.75} />
    <h2 className="font-bold text-xl sm:text-[25px] mt-4">Verification Submitted</h2>
    <p className="text-[15px] mt-3 max-w-[380px]">
      Thank you{name ? `, ${name}` : ''}. Your documents have been received. Our team will review them and contact you shortly.
    </p>
  </section>
);
